import ServiceCRUD from '../../../services/ServiceCRUDFLEXUC';

class SectorService extends ServiceCRUD {
  constructor() {
    super('/api/contextos');
  }
}

export default new SectorService();
